// Slot-style visual effects: coin bursts at the tap point, win banners, coin rain.
import { sfx } from "@/lib/sounds";

let pt = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
window.addEventListener("pointerdown", (e) => { pt = { x: e.clientX, y: e.clientY }; }, { passive: true, capture: true });

const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
const el = (cls, style, text, ms) => {
  const d = document.createElement("div");
  d.className = cls;
  Object.assign(d.style, style);
  if (text) d.textContent = text;
  document.body.appendChild(d);
  setTimeout(() => d.remove(), ms);
  return d;
};

export function coinBurst(x = pt.x, y = pt.y, n = 7) {
  if (reduced()) return;
  for (let i = 0; i < n; i++) {
    const a = (Math.PI * 2 * i) / n + Math.random() * 0.6;
    const r = 36 + Math.random() * 40;
    const d = el("fx-coin", { left: `${x}px`, top: `${y}px` }, "", 900);
    d.style.setProperty("--dx", `${Math.cos(a) * r}px`);
    d.style.setProperty("--dy", `${Math.sin(a) * r - 40}px`);
  }
  el("fx-plus", { left: `${x}px`, top: `${y}px` }, ["+1", "+5", "+10", "WIN", "+25"][Math.floor(Math.random() * 5)], 900);
}

export const reward = () => { sfx.pick(); coinBurst(); };

export const banner = (text) => { if (text) el("fx-banner", {}, text, 1500); };

export function coinRain(n = 26) {
  sfx.rain();
  if (reduced()) return;
  for (let i = 0; i < n; i++) {
    el("fx-rain", { left: `${Math.random() * 96}vw`, animationDelay: `${Math.random() * 0.6}s`, animationDuration: `${1.2 + Math.random() * 0.8}s` }, "", 2800);
  }
}
